<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span v-if="$route.params.id"> Редактировать сотрудника</span>
      <span v-else>Добавить сотрудника</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Основная информация</div>
        <div>
          <v-text-field label="ФИО" required type="text" outlined :rules="rules" v-model="item.fullName"></v-text-field>
        </div>
        <div>
          <v-text-field label="Должность" required type="text" outlined :rules="rules"
            v-model="item.position"></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="container-block">
      <div class="container-block-title">Электронная почта</div>
      <v-form ref="formEmail">
        <div class="d-flex" v-for="(item, index) in emails" :key="index">
          <v-text-field placeholder="Укажите почту" required type="text" outlined :rules="[
            (v) => !!v || 'Обязательно к заполнению',
            (v) => validatorMail(v) || 'Адрес почты введен некорректно',
          ]" v-model="item.email"></v-text-field>
          <div @click="deleteEmail(item.id)" class="mt-4 ml-4" v-if="emails.length > 1">
            <v-icon> mdi-delete </v-icon>
          </div>
        </div>
        <div @click="addEmail" class="container-block-gallery-button">
          Добавить электронную почту
        </div>
      </v-form>
    </div>
    <div class="container-block">
      <div class="container-block-title">
        Параметры публикации и отображения
      </div>
      <div class="d-flex align-center">
        <v-switch v-model="item.isHidden" hide-details color="var(--app-green-1)"></v-switch>
        <span class="switch-label">Скрыть из списка обращений (сотрудник не будет отображаться)</span>
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch v-model="item.isBelowSplitter" hide-details color="var(--app-green-1)"></v-switch>
        <span class="switch-label">Отображать под разделителем</span>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Фотография сотрудника</div>

      <v-file-input accept="image/*" outlined :rules="[
        (value) =>
          (value && value.size < 104857600) ||
          'Размер изображения не больше 100 мб',
      ]" hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
        label="Прикрепить изображение"></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div></div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px" v-if="newImage">
              <td class="text-left">Фото сотрудника</td>
              <td class="text-left">Основное фото сотрудника</td>
              <td class="text-left">
                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile" />
                  <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet" />
                  <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 100,
  height: 100,
}" image-restriction="stencil" @change="onChangeMobile" />
              </div>

              <div class="d-flex justify-center" style="width: 100%" v-if="resultImageMobile">
                <img width="100px" height="100px" :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropperTablet" :src="imgSrc" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 200,
  height: 200,
}" image-restriction="stencil" @change="onChangeTablet" />
              </div>

              <div class="d-flex justify-center" style="width: 100%" v-if="resultImageTablet">
                <img width="200px" height="200px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveItem" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn v-if="$route.params.id" @click="dialogDelete = true" outlined style="width: auto !important"
          color="var(--app-red-1)" class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить сотрудника?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    item: {
      isHidden: false,
      isBelowSplitter: false,
    },
    emails: [],

    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogTablet: false,
    dialogDelete: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),
  }),

  methods: {
    addEmail() {
      this.emails.push({
        id: Math.floor(Math.random() * 1000),
        email: "",
      });
    },
    deleteEmail(id) {
      this.emails = this.emails.filter((i) => i.id != id);
    },
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },

    openMobileImg() {
      this.dialogMobile = true;
      setTimeout(() => {
        this.$refs.cropperMobail.refresh();
      }, 500);

      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      setTimeout(() => {
        this.$refs.cropperTablet.refresh();
      }, 500);
      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletImage")) {
            this.formData.delete("tabletImage");
          }
          this.formData.append("tabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },

    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneImage")) {
            this.formData.delete("smartphoneImage");
          }
          this.formData.append("smartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },

    back() {
      this.$router.push({ name: "Appeal" });
    },

    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },

    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },

    saveItem() {
      if (this.$refs.formFirst.validate()) {
        if (this.newImage) {
          if (this.smartphoneMainImage && this.tabletMainImage) {
            this.errImages = false;
            const emails = this.emails
              .map((i) => {
                return i.email;
              })
              .filter((i) => i);
            if (this.item.id) {
              this.formData.append("appealEmployeeId", this.item.id || "");
            }
            this.formData.append("fullName", this.item.fullName || "");
            this.formData.append("position", this.item.position || "");

            this.formData.append("emails", JSON.stringify(emails));
            this.formData.append("isHidden", this.item.isHidden || "");
            this.formData.append(
              "isBelowSplitter",
              this.item.isBelowSplitter || ""
            );
            this.formData.append("originalImage", this.newImage || null);

            this.$axios
              .post(
                this.$store.getters.apiAdminPanelV2 + "/appeal/employee",
                this.formData,
                {
                  headers: {
                    authorization: this.$store.getters.adminPanelHeaderAuth,
                  },
                }
              )
              .then(() => {
                this.$router.push({ name: "Appeal" });
              })
              .catch((err) => {
                this.$store.commit("errorSet", true);
                this.$store.commit("errorTextSet", err);
              });
          } else {
            this.errImages = true;
          }
        } else {
          this.errImagesMain = true;
        }
      }
    },
    getItem() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/employee/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
          this.newImage = res.data.originalImage;
          this.smartphoneMainImage = res.data.smartphoneImage;
          this.tabletMainImage = res.data.tabletImage;
          this.imgSrc = res.data.originalImage;
          this.finishImageMobile = res.data.smartphoneImage;
          this.finishImageTablet = res.data.tabletImage;
          if (this.item.emails.length > 0) {
            this.item.emails.forEach((element) => {
              this.emails.push({
                id: Math.floor(Math.random() * 1000),
                email: element,
              });
            });
          } else {
            this.addEmail();
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteItem() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/appeal/employee", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            appealEmployeeId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Appeal" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },

  created() {
    if (!this.$route.params.id) {
      this.addEmail();
    } else {
      this.getItem();
    }
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
  {
  opacity: 0;
}
</style>